module.exports = __webpack_public_path__ + "img/incentive_edit.519b8e3b.png";